import CallToAction from "../components/CallToAction";
import CancellationPolicy from "../components/CancellationPolicy";
import HowItWorks from "../components/HowItWorks";
import ServiceCard from "../components/ServiceCard";
import servicesData from "../data/servicesData";
import { Link } from "react-router-dom";

function Services() {
	return (
		<section className="desktopMaxWidth servicesSection">
			<div
				className="sectionHeroContainer servicesHeroContainer"
				id="servicesHeroOnly"
			>
				<p className="sectionHeroTitle">Services</p>
				<p className="sectionHeroText">Home / Services</p>
			</div>
			<div className="servicesContainer">
				{Object.entries(servicesData).map(([key, service], index) => (
					<Link to={`/services/${key}`} key={index}>
						<ServiceCard
							icon={service.icon}
							title={service.title}
							text={service.text}
						/>
					</Link>
				))}
			</div>
			<HowItWorks />
			<CancellationPolicy />
			<CallToAction />
		</section>
	);
}

export default Services;
